class CollectionPdpLoader extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.products = this.querySelectorAll('.gg-product');
    this.currentActiveClass = null;
    this.currentActiveFilter = null;
    this.products.forEach(product => {
      product.addEventListener('click', () => {
        if (! product.dataset.productId || product.dataset.productId <= 0) {
          return;
        }
        // remove the previously active element
        if (this.currentActiveClass != null) {
          this.currentActiveClass.classList.remove('active');
        }
        // iterate through each element removing active ones
        else {
          this.products.forEach(activeProduct => {
            activeProduct.classList.remove('active');
          });
        }
        product.classList.add('active');
        this.currentActiveClass = product;


         //=============for Sticky bar
         const stickyProducts = document.querySelectorAll('product-info-sticky collection-pdp-loader .gg-product');
         if(stickyProducts.length > 0) {
            stickyProducts.forEach(pro => {
                 pro.classList.remove('active');
             });
             stickyProducts.forEach(pro => {
                if( product.dataset.productId == pro.dataset.productId) pro.classList.add('active');
             });
            
         }

        // update the price for the selected item
        if (document.querySelector('.price-container')) {
          document.querySelectorAll('.price-container').forEach(priceContainer => {
            if (! priceContainer.querySelector('.price-area')) {
              return;
            }
            var price = priceContainer.querySelector('.price-area');
            var priceParent = price.parentElement;
            // the variant price is available
            if (priceContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              priceParent.removeChild(price);
              priceParent.innerHTML += priceContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              setTimeout(function() {
                if (window.item) {
                    var _learnq = window._learnq || [];
                    function addedToCart() {
                      fetch(`${window.location.origin}/cart.js`)
                      .then(res => res.clone().json().then(data => {
                        var cart = {
                          total_price: data.total_price/100,
                          $value: data.total_price/100,
                          total_discount: data.total_discount,
                          original_total_price: data.original_total_price/100,
                          items: data.items
                        }
                        if (item !== 'undefined') {
                          cart = Object.assign(cart, item)
                        }
                        else {
                            _learnq.push(['track', 'Added to Cart', cart]);
                          }
                      }))
                    };
                    (function (ns, fetch) {
                      ns.fetch = function() {
                        const response = fetch.apply(this, arguments);
                        response.then(res => {
                          if (`${window.location.origin}/cart/add.js`
                            .includes(res.url)) {
                              addedToCart()
                          }
                        });
                        return response
                      }
                    }(window, window.fetch));
                    var atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
                    for (var i = 0; i < atcButtons.length; i++) {
                        atcButtons[i].addEventListener("click", function() {
                            _learnq.push(['track', 'Added to Cart', item]);
                        })
                    }
                  
                  window.item = {
                    Name: product.dataset.productTitle,
                    ProductID: product.dataset.productId,
                    Categories: product.dataset.productFabricType,
                    ImageURL: product.dataset.productImageUrl,
                    URL: product.dataset.productFullUrl,
                    Brand: "Nugget",
                    Price: product.dataset.productPrice,
                    CompareAtPrice: product.dataset.productCompareAtPrice
                  };
                  _learnq.push(['track', 'Viewed Product', item]);
                  _learnq.push(['trackViewedItem', {
                    Title: item.Name,
                    ItemId: item.ProductID,
                    Categories: item.Categories,
                    ImageUrl: item.ImageURL,
                    Url: item.URL,
                    Metadata: {
                      Brand: item.Brand,
                      Price: item.Price,
                      CompareAtPrice: item.CompareAtPrice
                    }
                  }]);
                }
                
              }, 100);
              
            } else {
              price.innerHTML = '';
            }
          })
        }
        // update the title for selected product 
        if (document.querySelector('.title-container')) {
          document.querySelectorAll('.title-container').forEach(titleContainer => {
            if (! titleContainer.querySelector('.title-area')) {
              return;
            }
            var title = titleContainer.querySelector('.title-area');
            if (titleContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              title.innerHTML = titleContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
            } else {
              title.innerHTML = '';
            }
            // change the URL to match the product location
            if (product.dataset.productTitle && product.dataset.productUrl) {
              // append to the current parameters set 
              var productUrl = product.dataset.productUrl;
              var currentUrl = new URL(window.location);
              if (currentUrl.searchParams.has('filter')) {
                productUrl = new URL(product.dataset.productUrl, currentUrl.origin);
                productUrl.searchParams.set('filter',currentUrl.searchParams.get('filter'));
              } 

              document.title = product.dataset.productTitle ?? 'Title';
              window.history.replaceState({"pageTitle":document.title}, '', productUrl.toString());
            }
          })
        }
         // update the aftership estimate
         if (document.querySelector('.aftership-edd-container')) {
          if (document.querySelector('.aftership-edd-container #afs-area')) {
            document.querySelector('.aftership-edd-container #afs-area').innerHTML = '';
          }
          document.querySelectorAll('.aftership-edd-container').forEach(asContainer => {
            var asfArea = asContainer.querySelector('#afs-area');
            if (asContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              var afsContent = asContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]');
              asfArea.innerHTML = afsContent.innerHTML;
              // extract the product and update the section accordingly
              if (afsContent.dataset.aftershipProduct) {
                window._asProduct = JSON.parse(decodeURI(afsContent.dataset.aftershipProduct));
                return;
              }
              if (asContainer.querySelector('.afs-area')) {
                var as = asContainer.querySelector('.afs-area');
              }
            } 
          })
        }
        // update lowstock indicator
        if (document.querySelector('.variant-lowstock-container')) {
          document.querySelectorAll('.variant-lowstock-container').forEach(lowstockContainer => {
            if (! lowstockContainer.querySelector('.variant-lowstock-area')) {
              return;
            }
            var lowstock = lowstockContainer.querySelector('.variant-lowstock-area');
            if (lowstockContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              lowstock.innerHTML = lowstockContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
            } else {
              lowstock.innerHTML = '';
            }
          })
        }
        // update upc metafield
        if (document.querySelector('.upc-section')) {
          document.querySelectorAll('.upc-section').forEach(upcSection => {
            if (! upcSection.querySelector('.upc-area')) {
              return;
            }
            var upcArea = upcSection.querySelector('.upc-area');
            if (upcSection.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              upcArea.innerHTML = upcSection.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
            } else {
              upcArea.innerHTML = '';
            }
          })
        }
        // update the custom accordion section
        if (document.querySelector('.custom-accordion-content')) {
          let isCustomAccordionOpen = false;
          document.querySelectorAll('.custom-accordion-content').forEach(ccAccordion => {
            if (! document.querySelector('.custom-accordion-output')) {
              return;
            }
            var accordionArea = document.querySelector('.custom-accordion-output');
            // determine if the accordion is currently open
            if (accordionArea.querySelector('.is-open') && accordionArea.querySelector('.is-open').hasAttribute('open')) {
              isCustomAccordionOpen = true;
            }
            if (ccAccordion.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              accordionArea.innerHTML = ccAccordion.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              if (accordionArea.querySelector('.cc-accordion')) {
                accordionArea.querySelector('.cc-accordion').classList.add('cc-initialized');
              }
              if (isCustomAccordionOpen && accordionArea.querySelector('.cc-accordion-item')) {
                accordionArea.querySelector('.cc-accordion-item').classList.add('is-open');
                accordionArea.querySelector('.cc-accordion-item').setAttribute('open', '');
              }
              accordionArea.addEventListener('click', function() {
                 let self = this;
                 self.querySelector('.cc-accordion-item').classList.toggle('is-open');
             });
            } else {
              accordionArea.innerHTML = '';
            }
          })
        }
        if (document.querySelector('.description-container')) {
          document.querySelectorAll('.description-container').forEach(descriptionContainer => {
            if (! descriptionContainer.querySelector('.description-area')) {
              return;
            }
            var description = descriptionContainer.querySelector('.description-area');
            if (descriptionContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              description.innerHTML = descriptionContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
            } else {
              description.innerHTML = '';
            }
          })
        } 
        if (document.querySelector('.buy-container')) {
          document.querySelectorAll('.buy-container').forEach(buyContainer => {
            if (! buyContainer.querySelector('.buy-area')) {
              return;
            }
            var buyArea = buyContainer.querySelector('.buy-area');
            var buyParent = buyArea.parentElement;
            if (buyContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]')) {
              buyParent.removeChild(buyArea);
              buyParent.innerHTML += buyContainer.querySelector('[data-variant-id="' + product.dataset.productId + '"]').innerHTML;
              var affirmObject = buyParent.querySelector('.buy-area .affirm-as-low-as');
              if (typeof affirmObject == 'object') {
                affirm.ui.refresh();
              }
            } else {
              buy.innerHTML = '';
            }
            // reset any notification links
            var modalLinks = document.querySelectorAll('.modalLink');
            for (let i = 0; i < modalLinks.length; i++) {
              modalLinks[i].addEventListener("click", function() {
                if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
                  document.getElementById(modalLinks[i].dataset.modal).classList.add('cc-popup--visible');
                }
              });
            }
            var closeModalLinks = document.querySelectorAll('.cc-popup-close-gg');

            for (let i = 0; i < closeModalLinks.length; i++) {
              closeModalLinks[i].addEventListener("click", function() {
                if (typeof document.getElementById(closeModalLinks[i].dataset.modalclose != 'undefined')) {
                  document.getElementById(closeModalLinks[i].dataset.modalclose).classList.remove('cc-popup--visible');
                }
              });
            }
          
            var closeModalLinksViaBG = document.querySelectorAll('.cc-popup-background');
            for (let i = 0; i < closeModalLinksViaBG.length; i++) {
              closeModalLinksViaBG[i].addEventListener("click", function() {
                if (typeof document.getElementById(closeModalLinksViaBG[i].dataset.modalclose != 'undefined')) {
                  document.getElementById(closeModalLinksViaBG[i].dataset.modalclose).classList.remove('cc-popup--visible');
                }
              });
            }
          })
        } 
        if (document.querySelector('#nugget-pdp-desktop-gallery') && ! document.querySelector('#nugget-pdp-desktop-gallery').classList.contains('js-hidden')) {
          window.activateStandardImageGallery(product.dataset.productId);
          window.currentVariantId = product.dataset.productId;
        } else {
          activatePdpMainSlider(product.dataset.productId);
          window.currentVariantId = product.dataset.productId;
          updateArrows();   
        }


        if (document.querySelector('[id^=nugget-pdp-slider-thumbnails]') && typeof pdpMainSlider == 'object') {
          // cleanup the image objects
          document.querySelectorAll('[id^=nugget-pdp-slider-thumbnails]').forEach((slide, index) => {
            // hide all slides that do not match the product
            slide.style.display = 'none';
            if (slide.dataset.productId != null && slide.dataset.variantId == product.dataset.productId) {
              slide.style.display = 'flex';
              if (typeof pdpMainThumbnailSlider[slide.dataset.productId] != 'undefined') {
                var s = pdpMainThumbnailSlider[slide.dataset.productId];
                if (pdpMainThumbnailVertical == true) {
                  s.update({ 
                    loop: false,
                        initial: 0,
                        slides: {
                          perView: 5,
                          spacing: 15,
                        },
                        vertical: true
                      }, 0
                    );
                } else {
                  s.update({ 
                    loop: false,
                        initial: 0,
                        slides: {
                          perView: 5,
                          spacing: 15,
                        },
                      }, 0
                    );
                }
                  s.slides.forEach((thumbnailSlide, thumbnailIndex) => {
                    if (thumbnailIndex == 0) {
                      thumbnailSlide.classList.add('active');
                    } else {
                      thumbnailSlide.classList.remove('active');
                    }
                  });                  
              }
            } 
          });
        }
        if (document.querySelector('[id^=nugget-pdp-slider-dots]') && typeof pdpMainSlider == 'object') {
          // cleanup the image objects
          document.querySelectorAll('[id^=nugget-pdp-slider-dots]').forEach((slide, index) => {
            // hide all slides that do not match the product
            slide.style.display = 'none';
            if (slide.dataset.productId != null && slide.dataset.variantId == product.dataset.productId) {
              slide.style.display = 'flex';
              if (typeof pdpMainDotsSlider[slide.dataset.productId] != 'undefined') {
                var s = pdpMainDotsSlider[slide.dataset.productId];
                s.update({ 
                  loop: false,
                      initial: 0,
                      drag:false,
                      slides: {
                        perView: 'auto',
                        spacing: 0,
                      },
                    }, 0
                  );
                  s.slides.forEach((dotSlide, dotIndex) => {
                    if (dotIndex == 0) {
                      dotSlide.classList.add('active');
                    } else {
                      dotSlide.classList.remove('active');
                    }
                  });                  
              }
            } 
          });
        }
      });
    });    
  }
}

if (!customElements.get("collection-pdp-loader"))
  customElements.define("collection-pdp-loader", CollectionPdpLoader);